import type { ApiEndpoint } from "@/shared/api-endpoint";
import { isObject } from "./utils/typeGuards";

export const kBpmClassifierRoute = "/bpm-classifier";

export const kBpmClassifierMin = 80;
export const kBpmClassifierMax = 159;

export interface BpmClassifierRequestBody {
    audioKey: string;
}

export interface BpmClassifierSuccessResponse {
    ok: true;
    bpm: number;
}

export const isBpmClassifierRequestBody = (value: unknown): value is BpmClassifierRequestBody =>
    isObject(value) && typeof value.audioKey === "string";

export const isBpmClassifierSuccessResponse = (
    response: unknown,
): response is BpmClassifierSuccessResponse =>
    isObject(response) && response.ok === true && typeof response.bpm === "number";

export const kBpmClassifierEndpoint: ApiEndpoint<
    BpmClassifierRequestBody,
    BpmClassifierSuccessResponse
> = {
    route: kBpmClassifierRoute,
    label: "BPM Classifier",
    source: "Modal",
    category: "Audio Analysis",
    description: "Predicts the BPM of an audio loop using an ML classifier.",
    isRequestBody: isBpmClassifierRequestBody,
    isSuccessResponse: isBpmClassifierSuccessResponse,
};
